// extracted by mini-css-extract-plugin
export default {"container":"project-card_container__W9pet","actions":"project-card_actions__Hy5oP","mobile":"project-card_mobile__p2erI"};